// extracted by mini-css-extract-plugin
export var completionBody = "_jl-2";
export var completionCard = "_jl-0";
export var completionFooter = "_jl-3";
export var completionTitle = "_jl-1";